import styled from "styled-components";

export const LoaderWrapper = styled.div`
    width: 20%;
    float: right;
    margin: 0 -32px 0 5px;
`;
